import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { FinancialEntityNameParams } from './service';

export enum FinancialEntityNameActions {
  Failure = '[Catalogs FinancialEntityName] Failure',
  Request = '[Catalogs FinancialEntityName] Request',
  Success = '[Catalogs FinancialEntityName] Success',
}

export const FinancialEntityNameFailure = createAction(
  FinancialEntityNameActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const FinancialEntityNameRequest = createAction(
  FinancialEntityNameActions.Request,
  props<{ parameters: FinancialEntityNameParams }>()
);

export const FinancialEntityNameSuccess = createAction(
  FinancialEntityNameActions.Success,
  props<{ data: ParameterResult }>()
);
